<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full gap-2">
    <ng-container *ngIf="rows.length > 0; else noneExcluded">
      <div class="text-sm" style="color: var(--p-text-muted-color)">
        The dashboard does not count these accounts. To count an account in this dashboard view, select
        'Include?'. When you open the dashboard again, it excludes the account again.
      </div>
      <app-ag-grid [gridOptions]="gridOptions" [rowData]="rows" [hasFooter]="false" class="flex-1 min-h-0"></app-ag-grid>
    </ng-container>
    <ng-template #noneExcluded>
      <div class="p-3">No account is set to Exclude from Dashboard Analytics. To exclude an account, open Edit Account.</div>
    </ng-template>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="rows.length === 0" (click)="ok()">
      <span>OK</span>
    </button>
    <button pButton type="button" class="p-button-raised" (click)="cancel()"><span>Cancel</span></button>
  </div>
</ng-template>
